import { Component, computed, inject } from '@angular/core';
import { ThemeService } from '../../services/theme/theme.service';

@Component({
  selector: 'app-loading',
  imports: [],
  templateUrl: './loading.component.html',
  styleUrl: './loading.component.scss'
})
export class LoadingComponent {
  private readonly themeService = inject(ThemeService);
  
  // Computed logo path based on theme
  readonly logoPath = computed(() => {
    const theme = this.themeService.currentTheme();
    return theme === 'dark' 
      ? 'assets/images/logo/DhofarLogo WHITE.png'
      : 'assets/images/logo/DhofarDarkLogo.png';
  });
}
